import React, { useRef, useState, useEffect } from "react";
import { useParams, useHistory, useLocation } from "react-router-dom";
import Moment from 'react-moment';
import 'moment/locale/es';
import moment from 'moment';
import { API } from "aws-amplify";
import Cookie from 'js-cookie';
import { Container, Row, Col, Button, Alert, Badge } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { Form } from "react-bootstrap/";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQrcode, faCheckCircle, faTimesCircle, faSpinner, faExclamationTriangle, faTicketAlt, faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import Linkify from 'react-linkify';
import ReactHtmlParser from 'react-html-parser'; 
import QrScanner from 'components/QrScanner';
import AdmissionListControl from 'components/AdmissionList';


import LoaderButton from "../components/LoaderButton";
import { onError, Notification } from "../libs/errorLib";
import { useAppContext } from "../libs/contextLib";
import { useFormFields } from "../libs/hooksLib";
import { renderCountryOptions } from "../libs/formsLib";
import config from '../config';

import "../../node_modules/noty/lib/noty.css";
import "../../node_modules/noty/lib/themes/bootstrap-v4.css";
import "./Show.css";

export default function ShowAdmissionList(props) {
    
  //const file = useRef(null);
  const { id } = useParams();
  const history = useHistory();
  const {isAuthenticated, getSession } = useAppContext();
  const [session, setSession] = useState(null);
  const [admin, setAdmin] = useState(false);
  const [show, setShow] = useState(null);
  const [tickets, setTickets] = useState(null); 
  const [showIsActive, setShowIsActive] = useState(false);
  const [ticket, setTicket] = useState(null);
  

  const [codes, setCodes] = useState([]);
  const [isLoading, setIsLoading] = useState(false); 
  const [showTicket, setShowTicket] = useState(null);
  const [showAdmission, setShowAdmission] = useState(false) 
  const [searchResults, setSearchResults] = useState([])
  const [selectedResult, setSelectedResult] = useState(null)
  

  const [status, setStatus] = useState('loading');

  const [fields, handleFieldChange, resetFields] = useFormFields({    
    selectedTicket: "none",
    search: ""
  });
  
  const linkifyComponentDecorator = (href, text, key) => (
    <a href={href} key={key} target="_blank">
        {text}
    </a>
    );

    useEffect(() => {

    // const searchParams = new URLSearchParams(location.search);
    // if (searchParams.get('activated') == "1") {
    //     Notification('success','Tu boleto ha sido activado exitosamente')
    // }

    async function onLoad() {
        try {           
            setIsLoading(true)
            let sess = getSession()
            setSession(sess)
            
            const show = await loadShow();
            setShowIsActive(['ACTIVE','STARTED','LIVE','REPLAY','SOLD OUT','TEST'].includes(show.status))
            await loadShowTickets(show)

            let allowed = false
            if (sess.user.roles.includes('Admin')) {
                allowed = true
                setAdmin(true)
            } else {
                const producer = sess.producers.find(p => p._id == show.producer)
                if (producer) {
                    allowed = true
                }
                // if (sess.producers.contains(show.producer))
            }
            if (allowed) {
                setShow(show)
            } else {
                history.push('/')
            }            

        } catch (e) {
            onError(e);
        } finally {
            setIsLoading(false)
        }
    }

    onLoad();
    }, [id]);

    /* API CALLS  */

    async function loadShow() {
        return API.get("vivelo", `/shows/${id}`);
    }

    async function loadShowTickets(show) {
        // const courtesiesFilter = props.courtesies ? '&courtesy=1' : ''
        // const paymentFilter = props.courtesies ? '' : '&paymentType=PREPAID'
        const courtesiesFilter = ''
        const paymentFilter = ''

        const tickets = await API.get("vivelo", `/shows/${show._id}/tickets?${courtesiesFilter}${paymentFilter}`);
        if (tickets && tickets.items && tickets.items.length > 0) {
            tickets.items.forEach(t => { t.selected = 0 })
            setTickets(tickets.items)
        }
        return tickets
    }

    function exitScanner() {
        setShowTicket(null)
    }

    function renderAdmissionList() {
        return show && tickets && (
            <AdmissionListControl 
                show={show}
                showTicket={showTicket ? tickets.find(t => t._id == showTicket) : null}
                onClose={exitScanner}
            />
        )
    }
    
    return (        
        !isLoading && show ? <>
        <Container fluid className="Show content content-dark">
            <div className="show-header">
                <div>
                    <div><h1>{show.fullname}</h1></div>
                    <div className="show-date"><Moment local format="ddd, LL - LT">{new Date(show.show_date)}</Moment></div>
                </div>
                <div className="show-actions">
                    <a href={`/shows/${id}/`} ><Button variant="outline-light">Info</Button></a>
                    <a href={`/shows/${id}/admission/qr`} ><Button variant="outline-light">Admisión QR</Button></a>
                    {/* <a href={`/shows/${id}/registration`} ><Button variant="outline-light">Registro</Button></a> */}
                </div>
            </div>
            <div>
                {renderAdmissionList()}
            </div>
        </Container>
        </> : null
    );
}